// **********************************************************
// Close Popup When Escape Key Press
// **********************************************************

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    const modalElem = document.querySelectorAll('.modal');
    if (modalElem.length > 0) {
      modalElem.forEach((el) => {
        el.classList.remove('is-open-modal');
        toggleBodyScrollLock(false);
      });
    }
  }
});

// **********************************************************
// Close Popup When Click On Outside & and Upsale modal click on add to cart
// **********************************************************

attachEvent('.modal__close,.modal__overlay', 'click', (ev) => {
  const parentEle = ev.target.closest('.modal');
  const productPopupEle = ev.target.closest('[modal-product-popup]');
  parentEle.classList.remove('is-open-modal');
  if (productPopupEle) {
    productPopupEle.classList.remove('body-scroll-locked');
  } else {
    toggleBodyScrollLock(false);
  }
  ev.preventDefault();
});
